module.exports = __webpack_public_path__ + "static/img/about-banner2.5ec384b4.png";